import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { Modal } from "components/layouts";
import { ConfirmPremiumServiceInterestForm } from "components/forms";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { GET_PREMIUM_SERVICE_INTEREST, CONFIRM_PREMIUM_SERVICE_INTEREST } from "./apollo";

export default function ConfirmPremiumServiceInterestContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_PREMIUM_SERVICE_INTEREST, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
  });

  const [confirmPremiumServiceInterest] = useMutation(CONFIRM_PREMIUM_SERVICE_INTEREST);

  const form = useFormik({
    initialValues: {
      assigneeInfo: {
        assignee: null as any,
      },
      extraInfo: {
        estimatedResolutionDate: "",
        digitalAddress: "",
        priority: "Low",
        notes: "",
      },
    },
    onSubmit: async (values) => {
      await confirmPremiumServiceInterest({
        variables: {
          id: searchParams.id,
          assignee: values.assigneeInfo?.assignee?._id,
          ...values.extraInfo,
        },
      }).then(({ data }) => {
        if (data.confirmPremiumServiceInterest?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "RAT Service Order Generated Successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not generate RAT Service Order",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      hideActions={true}
      title="Confirm Premium Service Interest"
      size="4xl"
      description="Provide the details to generate the Readiness Assessment Test"
    >
      {data?.premiumServiceInterest?._id && <ConfirmPremiumServiceInterestForm form={form} />}
    </Modal>
  );
}